import { AutocompleteOption } from '@cp/ds/src/components/form';
import { LocationSuggestion } from '@common/model/location/locationSuggestion';

export interface IAddressOption extends AutocompleteOption {
  location?: string;
}

export const toAddressOption = (s: LocationSuggestion): IAddressOption => ({
  label: s.address,
  location: s.location,
});
